const STYLE_BY_TYPE = {
  workorder: "bg-blue-100 text-blue-700 border-blue-200",
  project: "bg-violet-100 text-violet-700 border-violet-200",
  voorraad_magazijn: "bg-amber-100 text-amber-800 border-amber-200",
  nog_te_koppelen: "bg-rose-100 text-rose-700 border-rose-200",
};

const LABEL_BY_TYPE = {
  workorder: "Werkbon",
  project: "Project",
  voorraad_magazijn: "Voorraad / magazijn",
  nog_te_koppelen: "Nog te koppelen",
};

function normalizeAssociationType(value) {
  const raw = String(value || "").trim().toLowerCase();
  if (raw === "workorder") return "workorder";
  if (raw === "project") return "project";
  if (raw === "voorraad_magazijn") return "voorraad_magazijn";
  if (raw === "nog_te_koppelen") return "nog_te_koppelen";
  return "nog_te_koppelen";
}

export default function ProcurementOrderAssociationBadge({ associationType }) {
  const kind = normalizeAssociationType(associationType);
  const style = STYLE_BY_TYPE[kind] || STYLE_BY_TYPE.nog_te_koppelen;
  const label = LABEL_BY_TYPE[kind] || LABEL_BY_TYPE.nog_te_koppelen;

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${style}`}
      title={`Hoort bij: ${label}`}
    >
      {label}
    </span>
  );
}
